<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Prep Workflow Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading :title="`New ${sample_type.name} Workflow Process`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['add prep process']">
      <template #gated-content>
        <WorkflowPrepProcessForm :sample_type="sample_type" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils'
import WorkflowPrepProcessForm from '@/components/lab/workflows/prep/WorkflowPrepProcessForm'
import { LabRepositoryFactory } from '@/repositories/lab/LabRepositoryFactory'
import { notificationOptions } from '@/shared/toast-notification-options'
import { prepProcessNotifications } from '@/shared/notifications'
import { PrepWorkflowRoutes } from '@/router/lab/PrepWorkflowRoutes'

const PrepProcessRepository = LabRepositoryFactory.get('prepProcess')

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'WorkflowPrepProcessAdd',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkflowPrepProcessForm
  },
  data () {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
        ]
      }
    },
    route_root () {
      return PrepWorkflowRoutes.fetchRoot()
    }
  },
  async mounted () {
    this.loading = true

    this.sample_type = await getModel({
      model_type: 'sample_type',
      id: this.sample_type_id,
      message: this.$bvToast
    })

    this.sample_type ? (this.loading = false) : this.$router.back()
  },
  methods: {
    async submit (form_data) {
      try {
        const { data } = await PrepProcessRepository.create(form_data)

        this.addSuccess()
        this.$router.push(`/${this.route_root}/${this.sample_type_id}/${data.id}`)
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    }
  },
  notifications: prepProcessNotifications
}
</script>
